import axios from 'axios';
import Vue from 'vue';
import * as constants from '../constants';

export default {
  namespaced: true,

  state: {
    data: []
  },

  actions: {
    LOAD({ commit }, { filter }) {
      let params = {};
      if (filter) {
        for (let key in filter) {
          if (filter.hasOwnProperty(key) && filter[key] !== null) {
            params[key] = filter[key];
          }
        }
        if (filter.sortBy) {
          params.order_by = `${filter.sortBy}:${filter.descending ? 'DESC' : 'ASC'}`;
        }

        delete params.sortBy;
        delete params.descending;
        delete params.totalItems;
      }
      return new Promise((resolve, reject) => {
        axios.get(`${constants.SERVER_URL}/api/client-locations`, { params: params })
          .then(response => response.data)
          .then(response => {
            commit('CLIENT_LOCATIONS', response.data);
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    },

    LOAD_ONE({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios.get(`${constants.SERVER_URL}/api/client-locations/${id}`)
          .then(response => response.data)
          .then(response => {
            commit('CLIENT_LOCATIONS', [response.data]);
            resolve(response.data);
          }, (error) => {
            reject(error);
          });
      });
    },

    DELETE({ commit }, id) {
      commit('DELETE', id);
      return new Promise((resolve, reject) => {
        axios.delete(`${constants.SERVER_URL}/api/client-locations/${id}`)
          .then(response => {
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    },

    EDIT({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.put(`${constants.SERVER_URL}/api/client-locations/${data.id}`, data)
          .then(response => {
            commit('EDIT', response.data.data);
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    },

    ADD({ commit }, data) {
      return new Promise((resolve, reject) => {
        delete data.id;
        axios.post(`${constants.SERVER_URL}/api/client-locations/`, data)
          .then(response => {
            commit('ADD', response.data.data);
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    }
  },

  mutations: {
    CLIENT_LOCATIONS(state, payload) {
      state.data = payload;
    },

    EDIT(state, payload) {
      const index = state.data.findIndex(employee => employee.id === payload.id);
      if (index > -1) {
        Vue.set(state.data, index, payload);
      }
    },

    ADD(state, payload) {
      state.data.unshift(payload);
    },

    DELETE(state, id) {
      const index = state.data.findIndex(item => item.id === id);
      if (index > -1) {
        state.data.splice(index, 1);
      }
    }
  },

  getters: {
    clientLocationById: (state) => {
      const objectById = {};
      state.data !== null && state.data.forEach(item => {
        objectById[item.id] = item;
      });
      return objectById;
    },

    clientLocation: (state, getters) => (id) => getters.clientLocationById[id] ? getters.clientLocationById[id] : { name: '- Nedefinit -' }
  }
};



// WEBPACK FOOTER //
// ./src/store/clientsLocations.js